import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.scss';
import App from './components/App';
import { Helmet } from 'react-helmet';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <>
        <Helmet>
            <meta charSet="utf-8" />
            <title>Конструктор мебели для ванной комнаты от компании MOBO</title>
            <meta name="keywords" content="Mobo, конструктор, мебель, конструктор мебели" />
            <meta name="author" content="Dmitry Kalinin, Konstantin Agafonov" />
            <meta name="description" content="С помощью конструктора, вы в пару кликов сможете собрать мебель в ванную комнату и заказать ее прямо с сайта! Наши менеджеры получат и отправят сразу в производство." />
            <meta property="og:title" content="Конструктор мебели для ванной комнаты от компании MOBO" />
            <meta property="og:site_name" content="mobo.su конструктор" />
            <meta property="og:url" content="https://mobo.su/constructor/" />
            <meta property="og:description" content="С помощью конструктора, вы в пару кликов сможете собрать мебель в ванную комнату и заказать ее прямо с сайта! Наши менеджеры получат и отправят сразу в производство." />
            <link rel="icon" href="https://mobo.su/wp-content/uploads/2020/01/cropped-favicon-32x32.png" sizes="32x32" />
            <link rel="icon" href="https://mobo.su/wp-content/uploads/2020/01/cropped-favicon-192x192.png" sizes="192x192" />
        </Helmet>
        <App />
    </>
);

